import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../../../components/ContainerConteudo';
import CustomCol from '../../../../../../components/CustomCol';
import CustomInputInt from '../../../../../../components/CustomInputs/CustomInputInt';
import CustomInputText from '../../../../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../../../../components/CustomRow';
import CustomSelect from '../../../../../../components/CustomSelects/CustomSelect';
import Input from '../../../../../../components/InputNew';
import SelectInput from '../../../../../../components/InputNew/Select';
import StyledLink from '../../../../../../components/Link';
import Log from '../../../../../../components/Log/Log';
import SubAbas from '../../../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../components/WorkspaceFicha';
import { ICorRegistro } from '../../../../../../modules/types/Cor';
import {
  IDominioForm,
  IDominioRegistro,
} from '../../../../../../modules/types/Dominio';
import { getAllCores } from '../../../../../../services/cores/corService';
import { getDominioById } from '../../../../../../services/dominio/dominioService';
import theme from '../../../../../../theme';
import { functionLogData } from '../../../../../../utils/functionLogData';
import { formataNomeMeioSiglas } from '../../../../../../utils/functions';
import { handleDelete } from '../../../../../../utils/handleDelete';
import { handleSave } from '../../../../../../utils/handleSave';
import { swalAttention } from '../../../../../../utils/swal';
import {
  camposAjustar,
  camposObrigatorios,
} from '../../utils/camposObrigatoriosAjustar';
import { defaultFormMain } from '../../utils/formDominioDefault';
import { optionCorText } from '../../utils/optionCorText';
import { optionStatusBin } from '../../utils/optionStatusBin';
import SubAbasDominios from '../../utils/subabasDominios';
import DominioTipo from '../dominioTipo';

export default function DominioIdentificacao() {
  //COMPONENTE
  const params = useParams();
  const fichaID = String(params.id);

  const [logData, setLogData] = useState<IDominioRegistro | null>(null);
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);

  // FORMULÁRIO
  const [dataRaw, setDataRaw] = useState<IDominioForm | null>(null);
  const [formMain, setFormMain] = useState<IDominioForm>(defaultFormMain);

  //Buscar dados
  const fetchData = async (id: string | number): Promise<void> => {
    try {
      const registroData: IDominioRegistro = await getDominioById(String(id));
      setLogData(registroData);

      const formValues: IDominioForm = {
        id: registroData.id,
        dominioPaiId: registroData.dominioPaiId,
        corId: Number(registroData.cor.id),
        corText: registroData.corText,
        status: registroData.status,
        ordem: registroData.ordem,
        nome: registroData.nome,
        descricao: registroData.descricao,
        observacoes: registroData.observacoes ?? '',
      };

      setFormMain(formValues);
      setDataRaw(formValues);
      triggerRefresh();
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    if (fichaID !== 'undefined') {
      fetchData(fichaID);
    }
  }, [fichaID]);

  const subAbas =
    fichaID !== 'undefined'
      ? SubAbasDominios(fichaID)
      : [
          {
            label: 'Dados Gerais',
            rota: `/daf/adm/dominios/dominio/dadosgerais`,
          },
        ];

  const logs = functionLogData(logData);

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    setFormMain((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const salvar = () =>
    handleSave(
      formMain,
      camposObrigatorios,
      camposAjustar,
      'dominios',
      'daf/adm/dominios/dominio',
      fetchData,
      true,
      dataRaw,
    );

  const deletar = () => handleDelete(fichaID, 'dominios', 'daf/adm/dominios');

  const [allCores, setAllCores] = useState<ICorRegistro[]>([]);
  const [optionsCores, setOptionsCores] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    async function loadCores() {
      const cores = await getAllCores();
      setAllCores(cores);

      const opts = [
        { value: 0, label: 'Não informado' },
        ...cores
          .sort((a, b) => a.nomeCor.localeCompare(b.nomeCor))
          .map((cor) => ({
            value: cor.id,
            label: cor.nomeCor,
          })),
      ];

      setOptionsCores(opts);
    }

    loadCores();
  }, []);

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/adm/dominios"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          {logs && (
            <Log
              {...logs}
              entity="TB_DOMINIO"
              id={Number(formMain.id)}
              refreshTriggerLog={refreshTriggerLog}
            />
          )}

          {/* Identificação do Domínio */}
          <BoxConteudo boxTitulo="Identificação do Domínio">
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="140px">
                <CustomSelect
                  name="status"
                  options={optionStatusBin}
                  title="Status"
                  value={formMain.status}
                  onChange={handleChange}
                  style={{
                    backgroundColor:
                      Number(formMain.status) === 2
                        ? theme.colors.vermelho
                        : Number(formMain.status) === 1
                          ? theme.colors.verde
                          : 'white',
                    color:
                      Number(formMain.status) === 0 ? '#000000' : '#ffffff',
                  }}
                  required
                />
              </CustomCol>

              <CustomCol width="275px">
                <CustomSelect
                  name="corId"
                  options={optionsCores}
                  title="Cor do Background"
                  value={formMain.corId}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="150px">
                <CustomSelect
                  name="corText"
                  options={optionCorText}
                  title="Cor do Texto"
                  value={formMain.corText}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <CustomInputText
                  name="nome"
                  title="Nome do Domínio"
                  value={formMain.nome}
                  onChange={handleChange}
                  required
                  style={{
                    backgroundColor:
                      allCores.find((cor) => cor.id === Number(formMain.corId))
                        ?.codigoHexadecimal || '#ffffff',
                    color:
                      Number(formMain.corText) === 1
                        ? '#000000'
                        : Number(formMain.corText) === 2
                          ? '#ffffff'
                          : '#000000',
                  }}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <CustomInputText
                  name="descricao"
                  value={formMain.descricao}
                  title="Descrição"
                  type="textArea"
                  onChange={handleChange}
                  rows={5}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <CustomInputText
                  name="observacoes"
                  value={formMain.observacoes}
                  title="Observações"
                  type="textArea"
                  onChange={handleChange}
                  rows={3}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Tipo do Domínio */}
          {fichaID !== 'undefined' && <DominioTipo />}
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={deletar}
            save
            onClickSave={salvar}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={salvar} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
